<template>
  <component
    :is="headlineTag"
    :class="['headline-fi', `fi-text-size-df-${size}`, colorClass]"
  >
    <slot>
      <single-line-text-field-fi
        :field-name
        :fallback="htmlContent || field?.value"
      />
    </slot>
  </component>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import type { RichTextField, SingleLineTextField } from '@/sitecoreFieldTypes';
import colors from '@/tailwind/colors';

import SingleLineTextFieldFi from '../single-line-text-field-fi/SingleLineTextFieldFi.vue';

export type HeadlineTag =
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'
  | 'h7'
  | 'h8'
  | 'h9'
  | 'div'
  | 'span'
  | '';

defineOptions({
  name: 'HeadlineFi',
});

interface Props {
  tag?: HeadlineTag;
  size?: number;
  field?: SingleLineTextField | RichTextField | null;
  htmlContent?: string;
  color?: string;
  fieldName?: string | null | undefined;
}

const props = withDefaults(defineProps<Props>(), {
  tag: '',
  size: 48,
  field: null,
  htmlContent: undefined,
  color: '',
  fieldName: undefined,
});

const allowedTags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'h7', 'h8', 'h9', 'div', 'span'];

const colorClass = computed(() => {
  const colorValue = props.color && props.color in colors ? props.color : 'black';
  return `fi-text-${colorValue}`;
});

const headlineTag = computed(() => {
  let tag = 'h2';

  if (allowedTags.includes(props.tag)) {
    tag = props.tag;
  }

  return tag;
});
</script>

<style scoped src="./headline-fi" />
